import { css } from '@emotion/core';

import BasisGrotesqueRegularWOFF2 from '../assets/fonts/basis_grotesque_regular.woff2';
import BasisGrotesqueRegularWOFF from '../assets/fonts/basis_grotesque_regular.woff';

import BasisGrotesqueMediumWOFF2 from '../assets/fonts/basis_grotesque_medium.woff2';
import BasisGrotesqueMediumWOFF from '../assets/fonts/basis_grotesque_medium.woff';

import BasisGrotesqueBoldWOFF2 from '../assets/fonts/basis_grotesque_bold.woff2';
import BasisGrotesqueBoldWOFF from '../assets/fonts/basis_grotesque_bold.woff';

import PlantinRegularWOFF2 from '../assets/fonts/plantin_regular.woff2';
import PlantinRegularWOFF from '../assets/fonts/plantin_regular.woff';

const AppStyles = css`
  @font-face {
    font-family: 'Basis';
    font-weight: 400;
    src: url(${BasisGrotesqueRegularWOFF2}) format('woff2'),
      url(${BasisGrotesqueRegularWOFF}) format('woff');
  }

  @font-face {
    font-family: 'Basis';
    font-weight: 500;
    src: url(${BasisGrotesqueMediumWOFF2}) format('woff2'),
      url(${BasisGrotesqueMediumWOFF}) format('woff');
  }

  @font-face {
    font-family: 'Basis';
    font-weight: 700;
    src: url(${BasisGrotesqueBoldWOFF2}) format('woff2'),
      url(${BasisGrotesqueBoldWOFF}) format('woff');
  }

  @font-face {
    font-family: 'Plantin';
    font-weight: 400;
    src: url(${PlantinRegularWOFF2}) format('woff2'),
      url(${PlantinRegularWOFF}) format('woff');
  }

  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  html,
  body {
    color: #333;
    font-family: 'Basis Grotesque', 'Basis', 'sans-serif';
    height: 100%;
    margin: 0;
    padding: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  body {
    -webkit-overflow-scrolling: touch;
  }

  main {
    flex-grow: 1;
  }

  a {
    color: #333;
    text-decoration: none;
  }

  * {
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
  }

  button:focus {
    outline: none;
  }

  input {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
  }
`;

export default AppStyles;
